import React, {useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import {connect} from 'react-redux'

import Button from 'js/components/shared/Button'

import AccordionItem from './components/AccordionItem'
import InApartmentSection from './components/InApartmentSection'
import ServicesAndEquipSection from './components/ServicesAndEquipSection'
import FacilitiesSection from './components/FacilitiesSection'
import FamiliesAndPetsSection from './components/FamiliesAndPetsSection'
import ActivitiesAndWellbeingSection from './components/ActivitiesAndWellbeingSection'
import GoodToKnowSection from './components/GoodToKnowSection'
import ArrivalAndDepartureSection from './components/ArrivalAndDepartureSection'
import SustainableDevelopmentSection from './components/SustainableDevelopmentSection';
import RestaurantSection from './components/RestaurantSection'

import { FILTER_DATES } from 'js/components/search/constants'
import filterChange from 'js/components/search/actions/filters/filterChange'
import saveSectionData from './actions/saveSectionData'

import styles from './HotelInfoAccordion.module.scss'
import LazyRendering from '../../components/shared/LazyRendering';
import {SCROLL_TO_EVENT_KEY} from './constants';
import {scrollToSection} from './customEvents';

const cx = classnames.bind(styles)

const initData = window.drupalSettings?.accordionWidget
const hotelId = initData?.ajax?.hotelId
const initDataHeader = initData?.header || {}
const initDataSections = initData?.sections?.sort(((a, b) => a.order > b.order ? 1 : -1))
const sectionsMap = {
  'in_apartment': InApartmentSection,
  'services_and_equipments': ServicesAndEquipSection,
  'facilities': FacilitiesSection,
  'families_and_pets': FamiliesAndPetsSection,
  'activities_well_being': ActivitiesAndWellbeingSection,
  'good_to_know': GoodToKnowSection,
  'arrival_and_departure': ArrivalAndDepartureSection,
  'sustainable_development': SustainableDevelopmentSection,
  'restaurant': RestaurantSection,
}

const HotelInfoAccordion = function ({ saveSectionDataAction, filterChangeAction }) {
  const lazyContentRef = useRef()

  const onTitleLinkClick = function (e) {
    if (!initDataHeader.link.url) {
      e.preventDefault()
      filterChangeAction('activeFilter', FILTER_DATES)
    }
  }

  const onScrollToSection = function (e) {
    if (lazyContentRef?.current?.isVisible === false) {
      lazyContentRef?.current?.setIsVisible()

      setTimeout(() => {
        scrollToSection(e.detail.id)
      }, 100)
    }
  }

  useEffect(() => {
    initDataSections.forEach(function (section) {
      if (section.isExpanded && section.content) {
        saveSectionDataAction(hotelId, section.wid, section.content)
      }
    })

    window.addEventListener(SCROLL_TO_EVENT_KEY, onScrollToSection)

    return function () {
      window.removeEventListener(SCROLL_TO_EVENT_KEY, onScrollToSection)
    }
  }, [])

  return (
    <div className={cx('root')}>
      <div className={cx('header')}>
        {initDataHeader.title && (
          <div className={cx('title')} dangerouslySetInnerHTML={{__html: initDataHeader.title}} />
        )}
        {initDataHeader?.link?.title && (
          <Button
            href={initDataHeader.link.url}
            theme="squared"
            color="black"
            onClick={onTitleLinkClick}
          >
            {initDataHeader.link.title}
          </Button>
        )}
      </div>
      <LazyRendering ref={lazyContentRef} className={cx('sections')}>
        {initDataSections.map(section => (
          <AccordionItem
            key={section.wid}
            map={sectionsMap}
            hotelId={hotelId}
            className={cx('section')}
            data={section}
          />
        ))}
      </LazyRendering>
    </div>
  )
}

HotelInfoAccordion.propTypes = {
  data: PropTypes.any
}

export default connect(({}) => ({}), {
  saveSectionDataAction: saveSectionData,
  filterChangeAction: filterChange,
})(HotelInfoAccordion)
